import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const subTareaImporterSelectors = importerSelectors(
  'subTarea.importer',
);

export default subTareaImporterSelectors;
